import React from 'react';
import { CalciteBlock } from '@esri/calcite-components-react';
import styles from './RelatedLinks.module.scss';

const RelatedLinks = () => (
    <CalciteBlock heading = 'Links to related maps' description = 'various related maps can be found here' collapsible open>
  <div className={styles.RelatedLinks} data-testid='RelatedLinks'>
  <div><a href='https://nepassisttool.epa.gov/nepassist/nepamap.aspx' target = '_blank' rel = 'noreferrer'>NEPAssist</a></div>
  <div><a href='https://enviro.epa.gov/envirofacts/enviromapper/search' target = '_blank' rel = 'noreferrer'>EnviroMapper</a></div>
  <div><a href='https://enviro.epa.gov/myenvironment/' target = '_blank' rel = 'noreferrer'>myEnvironment</a></div>
  <div><a href='https://geopub.epa.gov/repoweringApp/' target = '_blank' rel = 'noreferrer'>RE-Powering Mapper</a></div>
  <div><a href='https://enviroatlas.epa.gov/enviroatlas/interactivemap/' target = '_blank' rel = 'noreferrer'>EnviroAtlas</a></div>
  <div><a href='https://www.epa.gov/fedfacts' target = '_blank' rel = 'noreferrer'>Federal Facilities Mapper</a></div>
  <div><a href='https://www.epa.gov/superfund/search-superfund-sites-where-you-live' target='_blank' rel='noreferrer'>Superfund Mapper</a></div>
  <div><a href='https://gems.lm.doe.gov' target='_blank' rel='noreferrer'>GEMS Mapper</a></div>
  <div><a href='http://www.epa.gov/debris-recovery-map' target='_blank' rel='noreferrer'>Disaster Debris Recovery Tool</a></div>
  <div><a href='https://experience.arcgis.com/experience/d3a227fc71c04f90bfdce2ca84f79620' target='_blank' rel='noreferrer'>Underground Storage Tanks (USTs) Finder</a></div>
  </div>
    </CalciteBlock>
);

export default RelatedLinks;
